<template>
  <Timeline
    :title="$t('nav.bubble_timeline')"
    :timeline="timeline"
    :timeline-name="'bubble'"
  />
</template>

<script src="./bubble_timeline.js"></script>
